var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-tutorial", { attrs: { steps: _vm.steps } }, [
    _c("div", [
      _c("h2", [
        _vm._v(
          "Olá! Vamos começar a avaliação técnica da sua equipe de gestores e de servidores?"
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Analise as responsabilidades dos gestores")]),
      _c("p", [
        _vm._v(
          " Selecione um gestor e avalie a forma como cada responsabilidade foi executada, durante os últimos doze meses. Ao lado de cada responsabilidade, aparecerá uma escala que vai de "
        ),
        _c("span", { staticClass: "info--text" }, [_vm._v('"Não executou"')]),
        _vm._v(" a "),
        _c("span", { staticClass: "info--text" }, [_vm._v('"Excelente"')]),
        _vm._v(". "),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v("Analise as responsabilidades da sua equipe de servidores"),
      ]),
      _c("p", [
        _vm._v(
          " As responsabilidades aparecerão na sua tela e, logo abaixo, aparecerá o nome de cada pessoa que trabalha no seu setor. Ao lado de cada nome, aparecerá uma escala que vai de "
        ),
        _c("span", { staticClass: "info--text" }, [_vm._v('"Não executou"')]),
        _vm._v(" a "),
        _c("span", { staticClass: "info--text" }, [_vm._v('"Excelente"')]),
        _vm._v(". "),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(
          "Selecione a forma de execução das responsabilidades da sua equipe"
        ),
      ]),
      _c("p", [
        _vm._v(
          " Clique na estrela que representa a forma como a responsabilidade foi executada, durante os últimos doze meses, pelo servidor da sua equipe. Caso a responsabilidade indicada não seja atribuição do servidor, clique no botão "
        ),
        _c("span", { staticClass: "info--text" }, [_vm._v('"Não se aplica" ')]),
        _vm._v(" ao lado da escala. "),
      ]),
      _c("p", { staticClass: "text-start" }, [
        _c("span", { staticClass: "info--text" }, [_vm._v("Não executou:")]),
        _vm._v(
          " é responsabilidade do servidor, mas não executou nos últimos 12 meses."
        ),
        _c("br"),
        _c("span", { staticClass: "info--text" }, [_vm._v("Não se aplica:")]),
        _vm._v(" não é responsabilidade do servidor. "),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Importante!")]),
      _c("ul", [
        _c("li", [
          _c("p", { staticClass: "text-start" }, [
            _c(
              "span",
              { staticClass: "font-weight-medium info--text text-lg-h6" },
              [
                _vm._v(
                  " Atenção! Gestor, sua avaliação técnica da equipe definirá a autoavaliação técnica de cada servidor. "
                ),
              ]
            ),
          ]),
        ]),
        _c("li", [
          _c("p", { staticClass: "text-start" }, [
            _c(
              "span",
              { staticClass: "font-weight-medium info--text text-lg-h6" },
              [
                _vm._v(
                  " Portanto, observe a utilização dos seguintes recursos: "
                ),
              ]
            ),
          ]),
        ]),
        _c("p", { staticClass: "text-start" }, [
          _c(
            "span",
            { staticClass: "font-weight-medium info--text text-lg-h6" },
            [
              _vm._v(
                " “Não se aplica” para que a responsabilidade não seja incluída na autoavaliação do servidor; "
              ),
            ]
          ),
          _c("br"),
          _c(
            "span",
            { staticClass: "font-weight-medium info--text text-lg-h6" },
            [
              _vm._v(
                " “Escala (estrelas)” para avaliar e incluir a responsabilidade na autoavaliação do servidor. "
              ),
            ]
          ),
        ]),
        _c("li", [
          _c("p", { staticClass: "text-start" }, [
            _c(
              "span",
              { staticClass: "font-weight-medium info--text text-lg-h6" },
              [
                _vm._v(
                  " A utilização incorreta do recurso “Não se aplica” ou da “Escala avaliativa” acarreta prejuízo na autoavaliação do servidor. "
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _c("p", { staticClass: "info--text" }, [
        _vm._v(
          " Lembre-se! Essa avaliação ajudará a direcionar a trilha de desenvolvimento da sua equipe de gestores e servidores da sua unidade. "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }